import React, { useEffect, useState } from "react";
import FormTextBox from "./micro_components/FormTextBox";

import CategoryDataService from "../services/CategoryService";
import DomainService from "../services/DomainService";
import BookDataService from "../services/BookService";
import { useHistory } from "react-router-dom";
import CreatorService from "../services/CreatorService";
import DeleteIcon from "@material-ui/icons/Delete";
import TextField from "@material-ui/core/TextField";
import { ChromePicker } from "react-color";
import OnOffSwitch from "./micro_components/OnOffSwitch";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
// import Switch from "@material-ui/core/Switch";
//loader
import axios from "axios";
import "./styles/MaterialAddBook.css";
import { useLocation } from "react-router-dom";

import { css } from "@emotion/react";
import SyncLoader from "react-spinners/SyncLoader";
import MenuDimensionsModal from "./micro_components/MenuDimensionsModal";
import HeresAmericaService from "../services/HA/HeresAmericaService.js";

import HeresAmerica from "./ha_components/HeresAmericaComponent";
import BookTitleAndCover from "./book_components/book_creation/BookTitleAndCover";
import DomainAndCategoriesSelector from "./book_components/book_creation/DomainAndCategoriesSelector";
import BookDetails from "./book_components/book_creation/BookDetails";
import Interlude from "./book_components/book_creation/Interlude";
import ButtonBar from "./book_components/book_creation/ButtonBar";

const override = css`
  position: abolute;
  left: vh;
`;

const loadingColor = "#8C9BD8";

const MaterialAddBook = ({ fromSlide = false, fromSlideBookId = null }) => {
  const initialBook = {
    title: "",
    domain_id: 7,
    bookCover: null,
  };
  const history = useHistory();
  const isNew = history.location.state || fromSlide ? false : true;

  const [book, setBook] = useState(isNew ? initialBook : {});
  const [bookCover, setBookCover] = useState("");
  // const [FreePDF, setFreePDF] = useState();
  const [allDomains, setAllDomains] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [roles, setRoles] = useState([]);
  const [allCreators, setAllCreators] = useState([]);
  const [domainCreators, setDomainCreators] = useState([]);
  const [selectedDomainId, setSelectedDomainId] = useState(1);
  const [description, setDescription] = useState("");
  const [primaryColor, setPrimaryColor] = useState("#ffffff");
  const [secondaryColor, setSecondaryColor] = useState("#ffffff");
  const [bookCoverLink, setBookCoverLink] = useState(null);
  const [isPublishing, setIsPublishing] = useState(false);
  const [pageThumbModalOpen, setPageThumbModalOpen] = useState(false);
  const [menuWidth, setMenuWidth] = useState(300);
  const [chapterThumbHeight, setChapterThumbHeight] = useState(90);
  const [pageThumbHeight, setPageThumbHeight] = useState(70);
  const [chapterTextFontSize, setchapterTextFontSize] = useState(22.4);
  const [chapterTextMaxWidth, setChapterTextMaxWidth] = useState(100);
  const [haBookLink, setHaBookLink] = useState("");
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(true);

  let existingBookId;

  if (fromSlide) {
    existingBookId = fromSlideBookId;
  } else if (history.location.state) {
    existingBookId = history.location.state.existingBookId;
  } else {
    existingBookId = null;
  }

  useEffect(() => {
    if (existingBookId == null) {
      return;
    }
    let cancelled = false;
    BookDataService.getPublishingData(existingBookId).then((data) => {
      if (cancelled || !data?.isPublishing) {
        return;
      }
      setIsPublishing(true);
      setBook((old) => {
        const newData = {
          ...old,
          publisher: data.publisher,
          price: data.price,
          type: data.type,
          slug: data.slug,
          publishingVideo: data.sampleVideo,
          revenue: data.revenue,
          creatorRevenues: data.creatorRevenues,
        };

        roles.forEach(
          (role) =>
            (newData[`creator${role.creator_id}`] =
              data.creatorRevenues[role.creator_name])
        );
        return newData;
      });
    });
    return () => {
      cancelled = true;
    };
  }, [existingBookId, roles]);

  useEffect(() => {
    setHaBookLink(bookCoverLink);
  }, [bookCoverLink]);

  // LOADING BUFFER
  useEffect(() => {
    if (book && allCategories && allDomains && allCreators) {
      setLoading(false);
    }
  }, [book, allDomains, allCategories, allCreators]);

  const loadAllCategories = (domainId) => {
    CategoryDataService.getAllInDomain(domainId)
      .then((response) => {
        var cats = [];
        for (var i in response.data) {
          cats[i] = response.data[i];
        }

        let formattedAllCategories = cats.map((c) => {
          return {
            id: c.id,
            name: c.name,
            domain_id: c.domain_id,
            groupName: c.groupName || c.group?.name || "Ungrouped",
          };
        });
        setAllCategories(formattedAllCategories);
      })
      .catch((e) => {
        console.log("error getting categories: " + e);
      });
  };
  // use effect to trigger re render of catergories if domain selected is changed
  useEffect(() => {
    loadAllCategories(selectedDomainId);
  }, [selectedDomainId]);

  //LOAD ANY DATA NEEDED (CATEGORIES, DOMAINS, CREATORS)
  useEffect(() => {
    DomainService.getAllMin() // returns  domaina  list  of json { id: int , name: "string"}
      .then((response) => {
        setAllDomains(response.data);
      })
      .catch((e) => {
        console.log("error getting domain list: " + e);
      });

    CreatorService.getAllMin() // returns creators a list of json obj {id : int , name: "string", lastName: string"   num_books: int , galleryImageURL "string", featuredArtist: null , domain_id }
      .then((response) => {
        setAllCreators(response.data);
      })
      .catch((e) => console.log("error getting creators: " + e));
    // IF this is EDIT Book
    if (!isNew && existingBookId) {
      console.log("testing");
      BookDataService.get(existingBookId)
        .then((response) => {
          // console.log("🚀 ~ file: MaterialAddBook.jsx:163 ~ useEffect ~ existingBookId:", existingBookId)
          // console.log("🚀 ~ file: MaterialAddBook.jsx:164 ~ useEffect ~ response:", response)
          // console.log(response.data)
          // let formatted = response.data;
          setBook(formattedData(response.data));

          setSelectedDomainId(response.data.domain_id);
          setPrimaryColor(response.data.primary_color);
          setSecondaryColor(response.data.secondary_color);
          setBookCoverLink(
            `https://d24hdgytax3x03.cloudfront.net/${existingBookId}/${response.data.coverFileName}`
          );
          // setPdfLink(`https://d24hdgytax3x03.cloudfront.net/${existingBookId}/${FreePDF[0].name}`)
          setRoles(response.data.roleDtos);
          // console.log(existingBookId)
        })
        .catch((e) => console.log("error getting book: " + e));

      CategoryDataService.getCategoriesForBook(existingBookId)
        .then((response) => {
          var cats = [];
          for (var i in response.data) {
            //1: "Music"
            cats[i] = response.data[i];
          }
          setSelectedCategories(
            cats.map((c) => {
              return { id: c.id, name: c.name };
            })
          );
        })
        .catch((e) => {
          console.log("error getting SELECTED categories: " + e);
        });

      // CreatorService.getRolesForBook(existingBookId)
      //   .then((response) => {
      //     setRoles(response.data);
      //   })
      //   .catch((e) => console.log("error getting roles for book: ", e));

      BookDataService.getBookDescription(existingBookId)
        .then((response) => setDescription(response.data))
        .catch((e) => console.log("error getting book description: ", e));

      BookDataService.getBookInfo(existingBookId)
        .then((res) => {
          setMenuWidth(res.data.bookInfo.menuWidth || 300);
          setChapterThumbHeight(res.data.bookInfo.chapterThumbHeight || 90);
          setPageThumbHeight(res.data.bookInfo.pageThumbHeight || 70);
          setchapterTextFontSize(res.data.bookInfo.chapterTextFontSize || 22.4);
          setChapterTextMaxWidth(res.data.bookInfo.chapterTextMaxWidth || 100);
        })
        .catch((e) => console.log("error getting book info: ", e.message));
    }
  }, [existingBookId]);

  useEffect(() => {
    if (selectedDomainId && allCreators) {
      setDomainCreators(
        allCreators.filter(
          (c) => Number(c.domain_id) === Number(selectedDomainId)
        )
      );
    }
  }, [allCreators, selectedDomainId]);

  const formattedData = (data) => {
    let formatted = data;
    if (data.primary_color == null) {
      formatted.primary_color = "#ffffff";
    }

    if (data.secondary_color == null) {
      formatted.secondary_color = "#ffffff";
    }

    return formatted;
  };

  //SET BOOK COVER FROM DROPZONE
  const handleBookCoverSet = (data) => {
    setBookCover(data);
  };

  //SAVE BOOK
  const saveBook = () => {
    const dataForBook = {
      title: book.title,
      domain_id: parseInt(book.domain_id),
      language: book.language,
      active: book.active,
      commentary: book.commentary,
      score: book.score,
      difficulty: book.difficulty,
      sampleVideoLink: book.sampleVideoLink,
      primary_color: book.primary_color,
      secondary_color: book.secondary_color,
      third_party_PDF_store: book.third_party_PDF_store,
      dpi_PDF_link: book.dpi_PDF_link,
      bookPin: book.bookPin,
      pdf_coupon: book.pdf_coupon,
      menuWidth: book.menuWidth,
      chapterThumbHeight: book.chapterThumbHeight,
      pageThumbHeight: book.pageThumbHeight,
      chapterTextMaxWidth: book.chapterTextMaxWidth,
      chapterTextFontSize: book.chapterTextFontSize,
      hideGradient: book.hideGradient,
    };

    // console.log("saving data book: ", dataForBook);
    // console.log("roles: ", roles);

    //when book is created, use its id to make relations with categories
    const updateCategories = async (id) => {
      let cat_ids = selectedCategories.map((c) => {
        return c.id;
      });

      // console.log("sending categories: " + JSON.stringify(cat_ids));

      CategoryDataService.updateBookCategories(id, cat_ids)
        .then((response) => {
          // console.log(response);
        })
        .catch((e) => {
          console.log("error uploading categories: " + e);
        });

      // history.push("/books");
    };

    if (isNew) {
      console.log(dataForBook);
      console.log("🚀 ~ saveBook ~ dataForBook:", dataForBook);
      BookDataService.create(dataForBook)
        .then(async (response) => {
          console.log("response from creating: ", response.data);
          await updateCategories(response.data.id);
          await addRoles(response.data.id);
          await uploadBookDescription(response.data.id);
          await saveNewBookCover(response.data.id);
          const idForRedirectRefresh = response.data.id;
          if (isPublishing) {
            dataForBook.publisher = book.publisher;
            dataForBook.price = book.price;
            dataForBook.type = book.type;
            dataForBook.revenue = book.revenue;
            dataForBook.publishingVideo = book.publishingVideo;

            const creatorRevenues = {};
            roles.forEach(
              (role) =>
                (creatorRevenues[role.creator_id] =
                  book[`creator${role.creator_id}`])
            );

            const pubData = {
              publisher: book.publisher,
              price: book.price,
              type: book.type,
              revenue: book.revenue,
              sampleVideo: book.publishingVideo,
              creatorRevenues,
            };

            BookDataService.addToPublishing(idForRedirectRefresh, pubData);
          }
          history.push(`/books/${idForRedirectRefresh}`);
        })
        .catch((e) => console.log("error saving book details: " + e));
    } else {
      updateCategories(existingBookId);
      addRoles(existingBookId);
      uploadBookDescription(existingBookId);

      BookDataService.update(existingBookId, book)
        .then((response) => {
          console.log(response);
          console.log("🚀 ~ .then ~ response:", response);
          setBook(response.data);

          if (isPublishing) {
            dataForBook.publisher = book.publisher;
            dataForBook.price = book.price;
            dataForBook.type = book.type;
            dataForBook.revenue = book.revenue;
            dataForBook.publishingVideo = book.publishingVideo;

            const creatorRevenues = {};
            roles.forEach(
              (role) =>
                (creatorRevenues[role.creator_id] =
                  book[`creator${role.creator_id}`])
            );

            const pubData = {
              publisher: book.publisher,
              price: book.price,
              type: book.type,
              revenue: book.revenue,
              sampleVideo: book.publishingVideo,
              creatorRevenues,
            };

            BookDataService.addToPublishing(existingBookId, pubData);
          }
        })
        .catch((e) => {
          console.log("error updating book: " + e);
        });
    }

    if (bookCover && !isNew) {
      saveBookCover();
    }

    //after save, go to home
    // history.push("/books");
  };

  // ADD ROLES
  const addRoles = async (id) => {
    // Skip blank/sentinel rows so we never POST creator_id: 0 or empty
    const validRoles = (roles || []).filter((role) => {
      const creatorId = Number(role.creator_id);
      return role.creator_id !== "" && role.creator_id != null && creatorId > 0;
    });

    CreatorService.addRolesForBook(id, validRoles)
      .then((response) =>
        console.log("uploaded roles for new book: ", response)
      )

      .catch((e) => {
        console.log("error uploading roles: " + e);
      });
  };

  // DELETE BOOK
  const deleteBook = () => {
    console.log("deleting book...");
    if (
      window.confirm("Are you sure you want to delete + " + book.title + "?")
    ) {
      BookDataService.remove(book.id)
        .then((response) => {
          history.push("/books");
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const revalidateBook = (slug) => {
    axios.get(
      `https://www.interludescores.com/api/revalidate?path=/books/${slug}&secret=Snapple`
    );
  };

  const uploadBookDescription = async (id) => {
    const data = new FormData();

    // const element = document.createElement("a");
    const file = new Blob([description], { type: "text/plain" });

    data.append("file", file);

    BookDataService.uploadBookDescription(id, data)
      .then((response) => console.log(response.data))
      .catch((e) => {
        console.log("error uploading description: " + e);
      });
  };

  const saveNewBookCover = async (id) => {
    setLoading(true);
    console.log("saving book cover!");
    BookDataService.postCoverImage(id, bookCover)
      .then((response) => {
        setLoading(false);
        console.log(response);
        // history.push("/books");
      })
      .catch((e) => {
        console.log("error posting book cover" + e);
      });
  };

  // SAVE BOOK COVER
  const saveBookCover = () => {
    setLoading(true);
    console.log("saving book cover!");

    BookDataService.postCoverImage(book.id, bookCover)
      .then((response) => {
        console.log(
          "🚀 ~ file: MaterialAddBook.jsx:455 ~ .then ~ response:",
          response
        );
        setLoading(false);

        // console.log(response);
        // history.push("/books");
      })
      .catch((e) => {
        console.log("error posting book cover" + e);
      });
  };

  //INPUT CHANGE
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBook({ ...book, [name]: value });
  };

  const applyMenuChanges = (
    menuWidth,
    chapterHeight,
    pageHeight,
    chapterTextMaxWidth,
    chapterTextFontSize,
    hideGradient
  ) => {
    setMenuWidth(menuWidth);
    setChapterThumbHeight(chapterHeight);
    setPageThumbHeight(pageHeight);
    setchapterTextFontSize(chapterTextFontSize);
    setChapterTextMaxWidth(chapterTextMaxWidth);
    setBook({
      ...book,
      menuWidth: menuWidth,
      chapterThumbHeight: chapterHeight,
      pageThumbHeight: pageHeight,
      hideGradient: hideGradient,
      ...(chapterTextFontSize && { chapterTextFontSize: chapterTextFontSize }),
      ...(chapterTextMaxWidth && { chapterTextMaxWidth: chapterTextMaxWidth }),
    });
  };

  //SET DOMAIN VALUE FROM DROP DOWN

  // const handlePrimaryColorChange = (color, event) => {
  //   setPrimaryColor(color.hex);
  //   setBook({ ...book, primary_color: color.hex });
  // };

  // const handleSecondaryColorChange = (color) => {
  //   setSecondaryColor(color.hex);
  //   setBook({ ...book, secondary_color: color.hex });
  // };

  const [needExternalBook, setNeedExternalBook] = useState(false);
  const location = useLocation();

  useEffect(() => {
    console.log(location);
    if (location.pathname === "/add") {
      setNeedExternalBook(true);
    }
  }, [location]);
  useEffect(() => {
    console.log("book: ", book);
  }, []);
  if (loading) {
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "40vh",
      }}
    >
      <SyncLoader
        color={loadingColor}
        loading={loading}
        css={override}
        style={{ marginLeft: "auto auto" }}
      />
    </div>;
  }

  return (
    <div className="add-book-form">
      <div className="top-container">
        <BookTitleAndCover
          book={book}
          bookCoverLink={bookCoverLink}
          handleInputChange={handleInputChange}
          setBookCover={setBookCover}
        />

        <DomainAndCategoriesSelector
          book={book}
          setBook={setBook}
          setSelectedDomainId={setSelectedDomainId}
          setSelectedCategories={setSelectedCategories}
          setRoles={setRoles}
          allDomains={allDomains}
          allCategories={allCategories}
          selectedCategories={selectedCategories}
          roles={roles}
          domainCreators={domainCreators}
          description={description}
          setPageThumbModalOpen={setPageThumbModalOpen}
          setDescription={setDescription}
        />
      </div>
      <hr />

      <div className="add-book-form__section middle-section">
        <BookDetails
          book={book}
          setBook={setBook}
          handleInputChange={handleInputChange}
          loading={loading}
        />
        <Interlude
          book={book}
          isNew={isNew}
          roles={roles}
          isPublishing={isPublishing}
          setIsPublishing={setIsPublishing}
          handleInputChange={handleInputChange}
        />
        <div className="heres-america">
          <HeresAmerica
            title={title}
            book={book}
            externalBookId={book.id}
            haBookLink={haBookLink}
            description={description}
            selectedCategories={selectedCategories}
            needExternalBook={needExternalBook}
          />
        </div>
      </div>

      {/* SAMPLE VIDEO */}
      <div className="add-book-form__section">
        <div className="add-book-form__field" style={{ marginBottom: "40px" }}>
          <h3>Sample Video</h3>
          <FormTextBox
            value={book.sampleVideoLink}
            label="Sample Video Link"
            initialValue={""}
            onChange={handleInputChange}
            name="sampleVideoLink"
          />
        </div>
      </div>

      {/* BUTTON BAR */}
      <ButtonBar
        isNew={isNew}
        id={book.id}
        selectedCategories={selectedCategories}
        book={book}
        setBook={setBook}
        isPublishing={isPublishing}
        roles={roles}
        existingBookId={existingBookId}
        bookCover={bookCover}
        description={description}
        setLoading={setLoading}
      />

      <MenuDimensionsModal
        open={pageThumbModalOpen}
        close={() => setPageThumbModalOpen(false)}
        isNew={isNew}
        menuWidth={menuWidth}
        chapterThumbHeight={chapterThumbHeight}
        pageThumbHeight={pageThumbHeight}
        applyChanges={applyMenuChanges}
        chapterTextFontSize={chapterTextFontSize}
        chapterTextMaxWidth={chapterTextMaxWidth}
      />
    </div>
  );
};

export default MaterialAddBook;
